import { createRouter, createWebHistory } from "vue-router";
import Login from "../views/Login.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import InvoiceTable from "../views/InvoiceTable.vue";
import InvoiceTabs from "../views/InvoiceTabs.vue";
import UserManagement from "../views/UserManagement.vue";
import OwnerDashboard from "../views/OwnerDashboard.vue";
import auth from "./auth";

const routes = [
  { path: "/", redirect: "/login", meta: { middleware: auth } },
  { path: "/login", name: "Login", component: Login, meta: { middleware: auth } },
  { path: "/recover-password", name: "RecoverPassword", component: ForgotPassword, meta: { middleware: auth } },
  { path: "/home", name: "Home", component: InvoiceTabs, meta: { middleware: auth } },
  { path: "/invoices", name: "InvoiceTable", component: InvoiceTable, meta: { middleware: auth } },
  { path: "/invoice-tabs", name: "InvoiceTabs", component: InvoiceTabs, meta: { middleware: auth } },
  { path: "/admin/users", name: "UserManagement", component: UserManagement, meta: { middleware: auth, requiresAdmin: true } },
  { path: "/owner/dashboard", name: "OwnerDashboard", component: OwnerDashboard, meta: { middleware: auth, requiresOwner: true } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.middleware) {
    return to.meta.middleware(to, from, next);
  }
  next();
});

export default router;


